module.exports = __webpack_public_path__ + "img/interShotRoutine1.438dfbfd.png";